<template>
  <div
    class="cpt-player-list"
    :class="[type]"
    v-if="playerList && playerList.length"
  >
    <div class="header">
      <div class="col-1">
        <div class="inner">
          <div class="team">
            <img v-hb-img.src="teamIcon" alt="" />
          </div>
          <div class="state">{{ type == 'green' ? '胜利' : '失败' }}</div>
        </div>
      </div>
      <div class="col-2">KDA</div>
      <div class="col-3">ACS</div>
      <div class="col-5">使用英雄</div>
    </div>
    <div class="player-list">
      <div class="player" v-for="(item, index) in playerList" :key="index">
        <div class="col-1">
          <div class="avatar image">
            <img v-hb-img.src="item.avatar" alt="" />
          </div>
          <div class="name">{{ item.player_name }}</div>
          <div class="nation image">
            <img v-hb-img.src="item.nationality_photo" alt="" />
          </div>
        </div>
        <div class="col-2 hel-font">
          {{ item.kda }}
          <template v-if="item.rating || item.rating === 0">
            (<span class="rating" :class="{ minus: item.rating < 0 }">{{
              item.rating | handleRating
            }}</span
            >)
          </template>
        </div>
        <div class="col-3 hel-font">{{ item.acs || '-' }}</div>
        <div class="col-5" :class="{ special: item.hero_list.length > 3 }">
          <div
            class="hero image"
            v-for="(icon, index) in item.hero_list"
            :key="index"
          >
            <img v-hb-img.src="icon" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'team-list-var',
  props: {
    teamInfo: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
    },
  },
  computed: {
    teamIcon() {
      return this.teamInfo.team_icon;
    },
    playerList() {
      return this.teamInfo.player_list || [];
    },
  },
  filters: {
    handleRating(num) {
      let symbol = num >= 0 ? '+' : '-';
      return symbol + Math.abs(num);
    },
  },
};
</script>

<style lang="less" scoped>
.cpt-player-list {
  position: relative;
  background: #f3f4f5;
  margin-top: 8px;

  &.red {
    &::before {
      background: rgb(180, 68, 79) !important;
    }

    .header {
      .col-1 {
        .inner {
          background: rgb(180, 68, 79);
        }
      }
    }
  }
  &.green {
    &::before {
      background: rgb(74, 153, 138) !important;
    }

    .header {
      .col-1 {
        .inner {
          background: rgb(74, 153, 138);
        }
      }
    }
  }

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 2px;
  }
  .header,
  .player-list .player {
    .col-1 {
      width: 96px;
    }
    .col-2 {
      width: 100px;
    }
    .col-3,
    .col-4 {
      width: 53px;
    }
    .col-5 {
      width: 88px;
    }
  }

  .header {
    height: 30px;
    display: flex;
    align-items: center;
    padding-right: 12px;
    justify-content: space-between;

    div:not(:first-child) {
      font-weight: 400;
      font-size: 11px;
      line-height: 16px;
      text-align: center;
      color: #8c9196;
      &.col-5 {
        text-align: start;
      }
    }

    .col-1 {
      height: 100%;

      .inner {
        height: 100%;
        display: flex;
        align-items: center;
        clip-path: polygon(0 0, 100% 0, 82px 100%, 0 100%);
        padding-left: 14px;
        .team {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: rgba(#fff, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;

          img {
            width: 16px;
            height: 16px;
            border-radius: 50%;
          }
        }

        .state {
          font-weight: 500;
          font-size: 13px;
          line-height: 18px;
          color: #ffffff;
        }
      }
    }
  }

  .player-list {
    .player {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 12px;
      height: 40px;
      position: relative;
      &:not(:last-child) {
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1px;
          transform: scaleY(0.5);
          background: rgba(218, 221, 224, 0.3);
        }
      }
      .col-1 {
        display: flex;
        align-items: center;
        padding-left: 10px;
        .avatar {
          width: 24px;
          height: 24px;
          border-radius: 2px;
          flex-shrink: 0;
          img {
            border-radius: 2px;
          }
        }
        .name {
          margin-left: 8px;
          font-size: 12px;
          font-weight: 600;
          color: #14191e;
          max-width: 48px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .nation {
          margin-left: 4px;
          width: 12px;
          height: 8px;
          flex-shrink: 0;
        }
      }
      .col-2,
      .col-3,
      .col-4 {
        color: #64696e;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .col-2 {
        .rating {
          color: #32b846;
          &.minus {
            color: #fa3c4b;
          }
        }
      }
      .col-5 {
        display: flex;
        justify-content: flex-start;
        &.special {
          .hero {
            flex-shrink: 0;
            width: 17px;
            height: 17px;
          }
        }
        .hero {
          width: 24px;
          height: 24px;
          &:nth-child(n + 2) {
            margin-left: 2px;
          }
        }
      }
    }
  }
}
</style>
